<template>
    <div class="slice">
        <div class="slice-content text-left">
            <Content v-if="data?.content" :readonly="readonly" :content="data.content" type="impressum" human-id="impressum" />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import {ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {Content} from '#components';
    import {useAuth, useAsyncData, createError} from '#imports';
    import {Configuration, LegalApiApi} from '@api';

    const auth = useAuth();
    const {user, loggedIn} = storeToRefs(auth);
    const readonly = ref(!loggedIn || !user.value?.roles.includes('ROLE_ADMIN'));

    const configuration = new Configuration({basePath: ''});
    const legalApi = new LegalApiApi(configuration);

    const {data, error} = await useAsyncData(() => legalApi.impressum(), {deep: true});
    if (!data.value || error.value) {
        throw createError({statusCode: 404, statusMessage: 'Page not found', fatal: true});
    }
</script>
